var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{'is-clone': _vm.row.status_.isClone,'is-new': _vm.row.status_.isNew,'is-edit': _vm.row.status_.isEdit}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }